import { h, Component } from "preact";

import Loading from "./Loading";

class ProjectList extends Component {
  render({ projects, accountUrl, isLoading }) {
    return (
      <div class="user-widget__list">
        <div class="user-widget__list__label">Results</div>
        <div class="user-widget__list__table">
          <div class="user-widget__list__line">
            <div class="user-widget__list__header">Name</div>
            <div class="user-widget__list__header">Project Id</div>
            <div class="user-widget__list__header">Owner</div>
            <div class="user-widget__list__header user-widget__list__cell--small">Plan</div>
            <div class="user-widget__list__header user-widget__list__cell--small">Links</div>
          </div>
          {projects &&
            projects.map(p => (
              <div class="user-widget__list__line">
                <div class="user-widget__list__cell">{p.project_title}</div>
                <div class="user-widget__list__cell">{p.project_id}</div>
                <div class="user-widget__list__cell"><a href={`${accountUrl}/uuid/user/${p.owner}`} rel="noopener noreferrer">{p.owner}</a></div>
                <div class="user-widget__list__cell user-widget__list__cell--small">{p.plan}</div>
                <div class="user-widget__list__cell user-widget__list__cell--small"><a href={p.project_ui} rel="noopener noreferrer">Go to project</a></div>
              </div>
            ))}
          {isLoading && <div class="user-widget__list__empty"><Loading /></div>}
          {isLoading === false && !projects && <div class="user-widget__list__empty">No projects were found.</div>}
        </div>
      </div>
    );
  }
}

export default ProjectList;



// WEBPACK FOOTER //
// ./src/ProjectList.js